/**
 * @generated SignedSource<<862e1c57cf2bb4bb177be30ea7dd3ce7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteRemindersTemplateInput = {
  clientMutationId?: string | null;
  templateId: string;
};
export type CommunicationRemindersPage_DeleteRemindersTemplate_Mutation$variables = {
  input: DeleteRemindersTemplateInput;
};
export type CommunicationRemindersPage_DeleteRemindersTemplate_Mutation$data = {
  readonly deleteRemindersTemplate: {
    readonly study: {
      readonly reminderTemplates: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
          } | null;
        } | null>;
      };
    } | null;
  } | null;
};
export type CommunicationRemindersPage_DeleteRemindersTemplate_Mutation = {
  response: CommunicationRemindersPage_DeleteRemindersTemplate_Mutation$data;
  variables: CommunicationRemindersPage_DeleteRemindersTemplate_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "RemindersTemplatesNodeConnection",
  "kind": "LinkedField",
  "name": "reminderTemplates",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RemindersTemplatesNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RemindersTemplatesNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CommunicationRemindersPage_DeleteRemindersTemplate_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteRemindersTemplatePayload",
        "kind": "LinkedField",
        "name": "deleteRemindersTemplate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StudyNode",
            "kind": "LinkedField",
            "name": "study",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CommunicationRemindersPage_DeleteRemindersTemplate_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteRemindersTemplatePayload",
        "kind": "LinkedField",
        "name": "deleteRemindersTemplate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StudyNode",
            "kind": "LinkedField",
            "name": "study",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "aba292cf423639c5487f0140242bffa0",
    "id": null,
    "metadata": {},
    "name": "CommunicationRemindersPage_DeleteRemindersTemplate_Mutation",
    "operationKind": "mutation",
    "text": "mutation CommunicationRemindersPage_DeleteRemindersTemplate_Mutation(\n  $input: DeleteRemindersTemplateInput!\n) {\n  deleteRemindersTemplate(input: $input) {\n    study {\n      reminderTemplates {\n        edges {\n          node {\n            id\n          }\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f4d9b8117938a7be76bdb3540aff0c33";

export default node;
